import { EARLY_ACCESS_TO_NEW_IN } from "../../state/modules/category/constants";

const shouldShowNewInTodayRibbon = ({
  loyaltyIsEnabled,
  loyaltyIsOptedIn,
  loyaltyBenefitType
}) =>
  loyaltyIsEnabled &&
  loyaltyBenefitType === EARLY_ACCESS_TO_NEW_IN &&
  loyaltyIsOptedIn;

export default shouldShowNewInTodayRibbon;
